import { html, utl_parseData } from "../base/_utils";
import Papa from "papaparse";

const dataWrapper = document.querySelector("#donationTracker");

async function getAndDisplayData() {
    const googleData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ_Q7BzVOLI6uwqjsZgUOh0t2dpAb0noUDOLgNZ8xrZz2AqcR1YJHj6j_ob1EfodvLnEiqt55DRjKr8/pub?output=csv";

    try {
        // Fetch and parse the data
        const results = await utl_parseData(googleData, Papa);
        let data = results.data;

        // Display the data
        for (let i = 0; i < data.length; i++) {
            dataWrapper.innerHTML += html`
                <td>${data[i].varSport}</td>
                <td>
                    <h5 class="font-primary-bold text-center text-white">${data[i].varTotalGiftsReceived}</h5>
                </td>
                <td>
                    <h5 class="font-primary-bold text-center text-white">${data[i].varTotalAmountRaised}</h5>
                </td>
            `;
        }
    } catch (error) {
        // Handle errors
        console.error("Error parsing data:", error);
    }
}

getAndDisplayData();
